import { render, staticRenderFns } from "./ArticleScreen.vue?vue&type=template&id=d419c61c&scoped=true&"
import script from "./ArticleScreen.vue?vue&type=script&lang=ts&"
export * from "./ArticleScreen.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleScreen.vue?vue&type=style&index=0&id=d419c61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d419c61c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
